define(function (require) {
    "use strict";

    var LE = require("app");
    var ErrorCodes = require("codeTables/errorCodes.json");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var OrganizeCollectionDecorator = require("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");

    var ProfileListLayout = require("user-management-views/profiles/ProfileListLayout");
    var ProfilesGridView = require("user-management-views/profiles/ProfilesGridView");
    var ProfileGridModel = require("user-management-models/ProfilesGridModel");
    var ProfileModel = require("models/entities/ProfileModel");
    var ProfileListComparators = require("user-management-comparators/ProfileListComparators");

    var ProfilesFilters = require("user-management-filters/ProfilesFilters");
    var CONST = require("const");
    var DEFAULT_COMPARATOR = function(model){
        return model.getName();
    };
    var DEFAULT_ORDERBY = "asc";
    var PAGE_SIZE = 25;

    var ProfileListController = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        ProfileListController = Marionette.Controller.extend({
            dataInitialized: false,
            viewInitialized: false,

            initialize: function (options) {
                this._initialize(options);
            },

            getView: function (options) {
                return this._getView(options);
            },
            onNavigateOut: function(){
                this._unbindEventsDataAndViews();
            },

            _initialize: function (options) {
                LEUserManagement.logger.debug("_initialize", "ProfileListController:_initialize");
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.PROFILE_LIST);
                this.profilesGridModel = new ProfileGridModel();
                this._bindEventsChannel();
            },

            _bindEventsChannel: function() {
                LEUserManagement.logger.debug("_bindEventsChannel", "ProfileListController:_bindEventsChannel");
                this.listenTo(this.channel, "paging:change", this._onPagingChange);
                this.listenTo(this.channel, "row:selector:click", this._onRowSelectorClick);
                this.listenTo(this.channel, "row:click", this._onRowClick);
                this.listenTo(this.channel, "actionMenu:select", this._onActionMenuSelect);
            },

            _getView: function(options) {
                LEUserManagement.logger.debug("_getView", "ProfileListController:_getView");
                this._unbindEventsDataAndViews();
                this._initData(options);
                this._initViews();
                this._bindEventsDataAndViews();
                return this.profileListLayout;
            },

            _initData: function(options) {
                LEUserManagement.logger.debug("_initData", "ProfileListController:_initData");
                if (!this.dataInitialized) {
                    LEUserManagement.logger.debug("_initData - initializing all data once", "ProfileListController:_initData");

                    var profilesCollection = LEUserManagement.getDataManager().getProfilesCollectionFullData();
                    profilesCollection = SelectableCollectionDecorator.decorate(profilesCollection);
                    this.profilesOrganizedCollection = OrganizeCollectionDecorator.decorate(profilesCollection, {
                        comparator: DEFAULT_COMPARATOR,
                        orderBy: DEFAULT_ORDERBY,
                        pageSize: PAGE_SIZE,
                        lazy: true
                    });

                    //this.profilesOrganizedCollection.reset(); //start the table collection empty until the first organize call, do not worry original is still full.

                    this.dataInitialized = true;
                }

            },

            _initViews: function() {
                LEUserManagement.logger.debug("_initViews", "ProfileListController:_initViews");
                if (!this.viewInitialized) {
                    LEUserManagement.logger.debug("_initData - initializing all views once", "ProfileListController:_initViews");

                    this.profileListLayout = new ProfileListLayout({
                        profilesCollection: this.profilesOrganizedCollection
                    });

                    this.profilesGridView = new ProfilesGridView({
                        collection: this.profilesOrganizedCollection,
                        model: this.profilesGridModel,
                        filters: ProfilesFilters,
                        comparators: ProfileListComparators,
                        isShowLoader: true,
                        textLoader: {
                            filtering: ProfilesGridView.LOADER_TEXT.FILTERING,
                            sorting: ProfilesGridView.LOADER_TEXT.SORTING
                        },
                        isShowAnimation: false
                    });

                    this.viewInitialized = true;
                }

            },

            _bindEventsDataAndViews: function() {
                LEUserManagement.logger.debug("_bindEventsDataAndViews", "ProfileListController:_bindEventsDataAndViews");
                this.listenTo(this.profileListLayout, "render", this._onLayoutRender);
                this.listenTo(this.profileListLayout, "show", this._onLayoutShown);  //listen to show not render ( we are using region add - this will trigger every time the view is seen )
                this.listenTo(this.profileListLayout, "close", this._onLayoutClose);

                this.listenTo(this.profilesOrganizedCollection ,"reset", this._onCollectionReset);
                this.profilesOrganizedCollection.bindToOriginalCollectionEvents();
            },

            //happens once
            _onLayoutRender: function() {
                LEUserManagement.logger.debug("_onLayoutRender", "ProfileListController:_onLayoutRender");
                this.profileListLayout.gridRegion.show(this.profilesGridView);
            },

            //happens every time
            _onLayoutShown: function() {
                LEUserManagement.logger.debug("_onLayoutShown", "ProfileListController:_onLayoutShown");
                this.profilesOrganizedCollection.organize({filterModel:this.profilesGridModel});
                this._showMigrationDoneMessage(); //TODO: check if needed
            },

            _showMigrationDoneMessage: function() {
                LEUserManagement.logger.debug("_showMigrationDoneMessage", "ProfileListController:_showMigrationDoneMessage");
                if (LE.context.get("migrationDone")) {
                    LE.context.set("migrationDone", null);
                    LEUserManagement.notifier.showSuccess(LE.translator.translate("LEFramework.upgrade.changed.permissions"));
                }
            },

            _onCollectionReset: function(collection, options) {
                this._handleActionMenu();
            },

            _onPagingChange: function(currentPageNumber) {
                LEUserManagement.logger.debug("_onPagingChange", "ProfileListController:_onPagingChange");
                this.profilesOrganizedCollection.organize({currentPage:currentPageNumber});
            },

            _onRowSelectorClick: function(options) {
                LEUserManagement.logger.debug("_onRowSelectorClick", "ProfileListController:_onRowSelectorClick");
                var itemModel = options.itemModel;
                var isChecked = options.isChecked;

                if (isChecked) {
                    var currentSelectedModel = this.profilesOrganizedCollection.getSelectedModel();
                    if (!_.isEmpty(currentSelectedModel)) {
                        currentSelectedModel.trigger("model:selection:change", false);
                    }
                    this.profilesOrganizedCollection.addToSelection(itemModel, {exclusively:true});
                    itemModel.trigger("model:selection:change", true);
                }
                else {
                    this.profilesOrganizedCollection.deselectModel(itemModel);
                    itemModel.trigger("model:selection:change", false);
                }

                this._handleActionMenu();
            },

            _onRowClick: function(userModel) {
                LEUserManagement.logger.debug("_onRowClick", "ProfileListController:_onRowClick");
                this._navigateToProfile(userModel.id);
            },

            _handleActionMenu: function() {
                LEUserManagement.logger.debug("_handleActionMenu", "ProfileListController:_handleActionMenu");
                var selectedModel = this.profilesOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {
                    this.channel.trigger("actionMenu:set", {id:ProfileListLayout.ACTION_MENU_ITEMS.EDIT, enabled:true});
                    this.channel.trigger("actionMenu:set", {id:ProfileListLayout.ACTION_MENU_ITEMS.DUPLICATE, enabled:true});
                    this.channel.trigger("actionMenu:set", {id:ProfileListLayout.ACTION_MENU_ITEMS.DELETE, enabled:selectedModel.id !== selectedModel.ACCOUNT_ADMIN_ID});
                }
                else {
                    this.channel.trigger("actionMenu:set", {id:ProfileListLayout.ACTION_MENU_ITEMS.EDIT, enabled:false});
                    this.channel.trigger("actionMenu:set", {id:ProfileListLayout.ACTION_MENU_ITEMS.DELETE, enabled:false});
                    this.channel.trigger("actionMenu:set", {id:ProfileListLayout.ACTION_MENU_ITEMS.DUPLICATE, enabled:false});
                }
            },

            _onActionMenuSelect: function(selectedItemId) {
                LEUserManagement.logger.debug("_onActionMenuSelect "+ selectedItemId, "ProfileListController:_onActionMenuSelect");
                switch (selectedItemId) {
                    case ProfileListLayout.ACTION_MENU_ITEMS.ADD:
                        this._onAddSelected();
                        break;
                    case ProfileListLayout.ACTION_MENU_ITEMS.EDIT:
                        this._onEditSelected();
                        break;
                    case ProfileListLayout.ACTION_MENU_ITEMS.DELETE:
                        this._onDeleteSelected();
                        break;
                    case ProfileListLayout.ACTION_MENU_ITEMS.DUPLICATE:
                        this._onDuplicateSelected();
                        break;
                }
            },

            _onAddSelected: function() {
                LEUserManagement.logger.debug("_onAddSelected ", "ProfileListController:_onAddSelected");
                this._navigateToProfile(CONST.ROUTING.NEW_ITEM_ID);
            },

            _onEditSelected: function() {
                LEUserManagement.logger.debug("_onEditSelected ", "ProfileListController:_onEditSelected");
                var selectedModel = this.profilesOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {
                    this._navigateToProfile(selectedModel.id);
                }
            },

            _onDeleteSelected: function() {
                LEUserManagement.logger.debug("_onDeleteSelected ", "ProfileListController:_onDeleteSelected");
                var selectedModel = this.profilesOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {

                    if (selectedModel.getNumOfAssingnedUsers() || (LE.sessionManager.hasLpaProfilesAssignmentFeature() && selectedModel.getIsAssignedToLPA())) {
                        LEUserManagement.notifier.showGlobalError({
                            title : LE.translator.translate("LEUserManagement.profileList.delete.assigned.users.header"),
                            content : LE.translator.translate("LEUserManagement.profileList.delete.assigned.users.text"),
                            removePrimaryButton: true
                        });
                    } else {

                        var message = LE.translator.translate({
                            key: "LEUserManagement.profileList.delete.confirm.text",
                            args: [{key: selectedModel.getName(), isTranslate: false}]
                        });

                        LEUserManagement.notifier.showConfirm({
                            title: LE.translator.translate("LEFramework.global.captions.are.you.sure"),
                            content: message,
                            objectAction: {
                                text: LE.translator.translate("LEFramework.global.captions.delete"),
                                callback: _.bind(this._onDeleteConfirmed, this)
                            }
                        });
                    }
                }
            },

            _onDeleteConfirmed: function() {
                LEUserManagement.logger.debug("_onDeleteConfirmed ", "ProfileListController:_onDeleteConfirmed");
                var selectedModel = this.profilesOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {

                    LEUserManagement.showLoader();
                    selectedModel.destroy({
                        success: _.bind(this._onDeleteSuccess, this),
                        error: _.bind(this._onDeleteError, this),
                        wait: true
                    });
                }
            },

            _onDeleteSuccess: function(model, resp, options) {
                LEUserManagement.logger.debug("_onDeleteSuccess ", "ProfileListController:_onDeleteSuccess");
                LEUserManagement.closeLoader();
                this.profilesOrganizedCollection.clearSelection();
            },

            _onDeleteError: function(model, resp, options) {
                LEUserManagement.logger.info("_onDeleteError ", "ProfileListController:_onDeleteError",resp);
                LEUserManagement.closeLoader();

                var errorMessage = LE.translator.translate({
                    key: "LEUserManagement.profileList.delete.error.text",
                    args: [{key: model.getName(), isTranslate: false}]
                });

                if (resp && resp.responseError && resp.responseError.internalCode === ErrorCodes.changingLastAdminProfile) {
                    if (model.getRoleTypeId().toString() === model.ROLES.ADMINISTRATOR) {
                        errorMessage = LE.translator.translate("LEUserManagement.profileEdit.errors.general.changingLastAdminProfile");
                    }
                    else {
                        errorMessage = LE.translator.translate({
                            key: "LEUserManagement.profileList.delete.error.lastProfileOfRole.text",
                            args: [{key: model.getName(), isTranslate: false}, {key: model.ROLES_BY_IDS[model.getRoleTypeId()], isTranslate: true}]
                        });
                    }
                }

                LEUserManagement.notifier.showError(errorMessage);
            },

            _onDuplicateSelected: function() {
                LEUserManagement.logger.debug("_onDuplicateSelected ", "ProfileListController:_onDuplicateSelected");
                var selectedModel = this.profilesOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {
                    LEUserManagement.showLoader();

                    this.duplicatedProfileModel = new ProfileModel();
                    if (false === this.duplicatedProfileModel.duplicate(
                            selectedModel,
                            {
                                success: _.bind(this._onDuplicateSuccess, this),
                                error: _.bind(this._onDuplicateError, this),
                                wait: true
                            },
                            selectedModel.collection)) {
                        LEUserManagement.closeLoader();
                        LEUserManagement.logger.error("Duplicating profile", "ProfileListController:_onDuplicateSelected");
                        throw new Error ("Duplicating profile - entityPathForDuplicate is missing on resource");
                    }
                }
            },

            _onDuplicateSuccess: function(model, resp, options) {
                LEUserManagement.logger.info("Profiles controller: user duplicated profile. new profile id: " +model.id, "ProfileListController:_onDuplicateSuccess");

                LEUserManagement.closeLoader();
                LEUserManagement.notifier.showSuccess(LE.translator.translate("LEUserManagement.permissionList.duplicate.success"));
                this._navigateToProfile(model.id);
            },

            _onDuplicateError: function(model, resp, options) {
                LEUserManagement.logger.error("error while duplicating profile", "ProfileListController:_onDuplicateError", resp);

                LEUserManagement.closeLoader();
                LEUserManagement.notifier.showError(LE.translator.translate("LEUserManagement.permissionList.duplicate.error"));
            },

            _onLayoutClose: function() {
                LEUserManagement.logger.debug("_onLayoutClose ", "ProfileListController:_onLayoutClose");
                this._unbindEventsDataAndViews();
            },


            _unbindEventsDataAndViews: function() {
                LEUserManagement.logger.debug("_unbindEventsDataAndViews ", "ProfileListController:_unbindEventsDataAndViews");
                if (this.profileListLayout) {
                    this.stopListening(this.profileListLayout);
                }
                if (this.profilesOrganizedCollection) {
                    this.stopListening(this.profilesOrganizedCollection);
                    this.profilesOrganizedCollection.unBindFromOriginalCollectionEvents();
                }

            },

            _navigateToProfile: function(profileId) {
                LEUserManagement.logger.debug("_navigateToProfile " + profileId, "ProfileListController:_navigateToProfile");
                LEUserManagement.router.navigate("profiles/"+profileId, {shuesmo:"esmi"});
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return ProfileListController;
});

